module.exports = __webpack_public_path__ + "img/note-icon.42cb8307.svg";